import { Box, FormLabel, TextField } from '@mui/material';
import { PrettoSlider } from '../../assets/styles/styles';
import { useAuthStore } from '../../store/storeAuth';

interface SliderFieldProps {
  label: string;
  name: string;
  value: number;
  onChange: (e: any) => void;
  min: number;
  max: number;
  step: number;
}

const SliderField = ({
  label,
  name,
  value,
  onChange,
  min,
  max,
  step,
}: SliderFieldProps) => {
  const { user } = useAuthStore(state => state);
  const isDark = user?.theme === 'dark';
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <FormLabel
        sx={{
          color: isDark ? '#D0D5DD' : '#101828',
          minWidth: '120px',
          flexShrink: 0,
        }}
      >
        {label}
      </FormLabel>
      <PrettoSlider
        step={step}
        min={min}
        name={name}
        value={Number(value)}
        max={max}
        style={{ marginLeft: '8px', width: '350px' }}
        onChange={onChange}
        className="nodrag"
      />
      <TextField
        type="number"
        value={value}
        name={name}
        onChange={onChange}
        InputProps={{
          inputProps: { min, max, step },
          style: { color: isDark ? '#D0D5DD' : '#101828' },
        }}
        style={{ marginLeft: '8px', width: '80px' }}
        className="nodrag"
        sx={{
          color: isDark ? '#D0D5DD' : '#101828',
          bgcolor: isDark ? '#1D2939' : '#F9FAFB',
          border: `2px solid ${isDark ? '#475467' : '#EAECF0'}`,
        }}
      />
    </Box>
  );
};

export default SliderField;
